module.exports = __webpack_public_path__ + "static/media/check.561ccaa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/JoinContainer/check.svg
// module id = 350
// module chunks = 0